
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearSession, getSessionName } from '../services/authService';
import { LogOut, LayoutDashboard } from 'lucide-react';
import './NavBar.css';

const navBtnBase = {
    background: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '6px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '110px',
    height: '36px',
    gap: 6,
    fontSize: '0.8rem',
    fontWeight: 600,
    transition: 'background 0.15s',
};

const NavBar = () => {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");

    useEffect(() => {
        getSessionName().then(setUserName);
    }, []);

    const handleLogout = () => {
        clearSession();
        navigate('/login', { replace: true });
    };

    const getUserInitials = (name) => {
        const nameParts = (name || '').trim().split(/\s+/).filter(Boolean);

        if (nameParts.length === 0) return 'U';
        if (nameParts.length === 1) return nameParts[0].slice(0, 2).toUpperCase();

        return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
    };

    const userInitials = getUserInitials(userName);

    return (
        <header className="border-bottom sticky-top header-nav" style={{ zIndex: 1030, backgroundColor: "#D3E8FF", boxShadow: "0 4px 1px rgba(0, 0, 0, 0.15)", flexShrink: 0 }}>
            <div className="container-fluid d-flex align-items-center justify-content-between py-2 px-4 navbar-container">
                <div className="d-flex align-items-center" style={{ gap: 5 }}>
                    <div className="rounded-circle border d-flex align-items-center justify-content-cover pt-2 logo-container">
                        <img src="/AT_FullLogo.png" alt="logo" className="logo-img" />
                    </div>
                </div>

                <div className="position-absolute start-50 translate-middle-x text-center title-container">
                    <div className="fw-bold main-title" style={{ color: "#006BB3", fontSize: "1.5rem" }}>
                        FNOL
                    </div>
                    <div className="small text-muted subtitle">Central hub for reviewing and processing incoming FNOL.</div>
                </div>

                <div className="d-flex align-items-center" style={{ gap: 12 }}>
                    {/* {userName && (
                        <span style={{ color: '#006BB3', fontWeight: 600, fontSize: '0.9rem' }}>
                            Welcome, {userName}
                        </span>
                    )} */}
                    <div
                        aria-label="user avatar"
                        className="rounded-circle border profile-img d-flex align-items-center justify-content-center"
                        style={{ backgroundColor: '#006BB3', color: '#ffffff', fontWeight: 700, fontSize: '1rem', lineHeight: 1 }}
                    >
                        {userInitials}
                    </div>
                    <button
                        onClick={() => navigate('/dashboard')}
                        title="Go to Dashboard"
                        style={{ ...navBtnBase, border: '1.5px solid #006bb3', color: '#006bb3' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#e0f0ff'}
                        onMouseLeave={e => e.currentTarget.style.background = 'none'}
                    >
                        <LayoutDashboard size={15} />
                        Dashboard
                    </button>
                    <button
                        onClick={handleLogout}
                        title="Logout"
                        style={{ ...navBtnBase, border: '1.5px solid #dc2626', color: '#dc2626' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'}
                        onMouseLeave={e => e.currentTarget.style.background = 'none'}
                    >
                        <LogOut size={15} />
                        Logout
                    </button>
                </div>
            </div>
        </header>
    );
};

export default NavBar;
